import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Sparkles, Info } from "lucide-react";

export default function VersionBadge({ autoOpen = false }) {
  const [info, setInfo] = useState(null);
  const [open, setOpen] = useState(false);
  const [isNew, setIsNew] = useState(false);

  useEffect(() => {
    api.get("/platform/version").then(({ data }) => {
      setInfo(data);
      if (!autoOpen || !data?.version) return;
      const seen = localStorage.getItem("nx_seen_version");
      if (seen === null) localStorage.setItem("nx_seen_version", data.version);
      else if (seen !== data.version) {
        setIsNew(true);
        // espera a que el usuario elija sucursal (si aplica) antes de mostrar las novedades
        const t = setInterval(() => { if (!document.querySelector('[data-testid="branch-picker"]')) { clearInterval(t); setOpen(true); } }, 700);
      }
    }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const close = (v) => { setOpen(v); if (!v && info?.version) { localStorage.setItem("nx_seen_version", info.version); setIsNew(false); } };

  if (!info) return null;
  const lines = (info.notes || "").split("\n").map((l) => l.trim()).filter(Boolean);

  return (
    <>
      <button onClick={() => setOpen(true)} data-testid="version-badge"
        className="flex items-center gap-1.5 text-[11px] font-semibold px-3 py-1 rounded-full border bg-emerald-500/10 border-emerald-500/30 text-emerald-700 hover:bg-emerald-500/20 transition-colors">
        <Sparkles size={13} /> Versión: {info.version}
      </button>

      <Dialog open={open} onOpenChange={close}>
        <DialogContent className="max-w-md" data-testid="version-dialog">
          <DialogHeader>
            <DialogTitle className="font-display flex items-center gap-2">
              <Sparkles size={18} className="text-emerald-600" /> {isNew ? "¡Nueva actualización!" : "ProfesionalPOS"} · Versión {info.version}
            </DialogTitle>
            {isNew && <p className="text-xs text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-md px-2 py-1" data-testid="version-new-hint">Tu sistema se actualizó. Esto es lo nuevo:</p>}
          </DialogHeader>
          <div className="space-y-3">
            <div className="text-xs text-muted-foreground flex items-center gap-1">
              <Info size={12} /> Novedades de esta versión
            </div>
            {info.updated_at && <div className="text-[11px] text-muted-foreground">Publicada el {new Date(info.updated_at).toLocaleDateString("es-MX", { day: "numeric", month: "long", year: "numeric" })}</div>}
            {lines.length > 0 ? (
              <ul className="space-y-1.5 text-sm list-disc pl-5" data-testid="version-notes">
                {lines.map((l, i) => <li key={i}>{l.replace(/^[-•]\s*/, "")}</li>)}
              </ul>
            ) : (
              <p className="text-sm text-muted-foreground">Sin descripción de mejoras.</p>
            )}
            <button type="button" onClick={() => close(false)} className="w-full h-10 rounded-md bg-emerald-500 hover:bg-emerald-600 text-white font-bold text-sm" data-testid="version-dialog-ok">Entendido</button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
